module.exports = __webpack_public_path__ + "static/media/treeWithLeaf.ed573649.png";